import React from 'react';
import ReportingFinancesLedgerLineItemsPage from '../components/ReportingFinancesLedgerLineItemsPage';

const ReportingFinancesLedgerLineItemsApp = (props) => (
  <ReportingFinancesLedgerLineItemsPage {...props} />
);

export default ReportingFinancesLedgerLineItemsApp;
